// extracted by mini-css-extract-plugin
export default {"help_text_title":"fYnv","help_text_description":"_2Scb"};